module.exports = require("npm-check-updates");